import(/* webpackMode: "eager" */ "/var/www/rentzeme/app/src/app/global-error.jsx");
